import { Link } from 'react-router-dom';
import { allInOneData } from '@/mocks/more-products';
import ConsultationForm from '@/components/ConsultationForm';

function AllInOnePage() {
  return (
    <>
      {/* Banner */}
      <section className="relative w-full h-[420px] md:h-[520px] overflow-hidden">
        <div className="absolute inset-0 bg-primary-950/85 z-0" />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/20 to-black/50 z-[1]" />
        <div className="absolute inset-0 z-[1]">
          <img src="/images/banner-bg.jpg" alt="智译一体机" className="w-full h-full object-cover object-top opacity-35" />
        </div>
        <div className="relative z-10 h-full flex flex-col items-center justify-center px-4 md:px-8 text-center">
          <div className="w-full max-w-4xl mx-auto">
            <span className="inline-block px-4 py-1.5 mb-6 text-xs md:text-sm font-medium text-white/80 border border-white/25 rounded-full backdrop-blur-sm">{allInOneData.banner.tag}</span>
            <h1 className="text-3xl md:text-5xl font-extrabold text-white tracking-tight leading-tight mb-6">{allInOneData.banner.title}</h1>
            <p className="text-sm md:text-base text-white/70 leading-relaxed max-w-3xl mx-auto mb-8">{allInOneData.banner.desc}</p>
            <div className="mt-4 translate-y-16 flex flex-col sm:flex-row items-center justify-center gap-4">
              <a href="#consultation" className="inline-flex items-center px-8 py-3.5 bg-white text-primary-600 text-sm md:text-base font-semibold rounded-full hover:bg-primary-50 transition-all duration-200 whitespace-nowrap cursor-pointer">
                <i className="ri-customer-service-2-line mr-2"></i>购买咨询
              </a>
              <a href="tel:400-097-5066" className="inline-flex items-center px-8 py-3.5 bg-primary-600 text-white text-sm md:text-base font-semibold rounded-full hover:bg-primary-700 border border-primary-400 transition-all duration-200 whitespace-nowrap cursor-pointer">
                <i className="ri-phone-line mr-2"></i>400-097-5066
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* CTA（已注释，按钮已移入顶部 Banner） */}
      {/* <section className="py-12 md:py-16 px-4 md:px-8 lg:px-12 bg-primary-500">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-2xl md:text-3xl font-bold text-white mb-4">{allInOneData.cta.title}</h2>
          <p className="text-white/75 text-sm md:text-base mb-8">{allInOneData.cta.desc}</p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a href="#consultation" className="px-8 py-3.5 bg-white text-primary-600 text-sm md:text-base font-semibold rounded-full hover:bg-primary-50 transition-all duration-200 whitespace-nowrap cursor-pointer"><i className="ri-customer-service-2-line mr-2"></i>在线咨询</a>
            <a href="tel:400-097-5066" className="px-8 py-3.5 bg-primary-600 text-white text-sm md:text-base font-semibold rounded-full hover:bg-primary-700 border border-primary-400 transition-all duration-200 whitespace-nowrap cursor-pointer"><i className="ri-phone-line mr-2"></i>400-097-5066</a>
          </div>
        </div>
      </section> */}

      {/* 产品功能介绍 */}
      <section className="py-16 md:py-24 px-4 md:px-8 lg:px-12 bg-background-50">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-12 md:mb-16">
            <span className="inline-block px-4 py-1.5 mb-4 text-xs font-medium text-primary-600 bg-primary-50 rounded-full">产品功能</span>
            <h2 className="text-2xl md:text-4xl font-bold text-foreground-900">{allInOneData.introduce.title}</h2>
          </div>
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-5 md:gap-8">
            {allInOneData.introduce.items.map((item, idx) => (
              <div key={idx} className="flex flex-col items-center text-center p-6 md:p-8 bg-white rounded-2xl border border-background-200 hover:border-primary-200 transition-all duration-300">
                <div className="w-16 h-16 flex items-center justify-center rounded-2xl bg-primary-50 mb-5">
                  <img src={item.icon} alt={item.name} className="w-8 h-8 object-contain" />
                </div>
                <h3 className="text-lg md:text-xl font-bold text-foreground-900 mb-2">{item.name}</h3>
                <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* 产品优势 */}
      <section className="py-16 md:py-24 px-4 md:px-8 lg:px-12 bg-background-100">
        <div className="max-w-5xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-10 md:gap-16 items-center">
            <div className="flex justify-center">
              <div className="relative w-64 h-64 flex items-center justify-center">
                <img src={allInOneData.advantages.image} alt="产品优势" className="absolute inset-0 w-full h-full object-contain" />
                <span className="relative text-2xl md:text-3xl font-bold text-foreground-800">{allInOneData.advantages.title}</span>
              </div>
            </div>
            <div className="space-y-6 md:space-y-8">
              {allInOneData.advantages.items.map((adv, idx) => (
                <div key={idx} className="flex items-start gap-3">
                  <img src={allInOneData.advantages.icon} alt="" className="w-7 h-5 mt-1.5 flex-shrink-0 object-contain" />
                  <span className="text-sm md:text-base text-foreground-600 leading-relaxed">{adv}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* 软硬件配置 */}
      <section className="py-16 md:py-24 px-4 md:px-8 lg:px-12 bg-background-50">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-12 md:mb-16">
            <span className="inline-block px-4 py-1.5 mb-4 text-xs font-medium text-accent-600 bg-accent-50 rounded-full">硬件配置</span>
            <h2 className="text-2xl md:text-4xl font-bold text-foreground-900">{allInOneData.config.title}</h2>
          </div>

          {/* 产品外观图 */}
          <div className="flex flex-wrap items-end justify-center gap-10 md:gap-20 mb-16 md:mb-24">
            {allInOneData.config.photos.map((p, idx) => (
              <img key={idx} src={p.src} alt={p.alt} className="h-72 md:h-[420px] w-auto object-contain" />
            ))}
          </div>

          {/* 硬件配置规格 */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12">
            {allInOneData.config.specs.map((spec, idx) => (
              <div key={idx} className="text-center">
                <h3 className="text-lg md:text-xl font-bold text-foreground-900 mb-5">{spec.title}</h3>
                <div className="bg-white rounded-2xl border border-background-200 p-4 md:p-6 overflow-hidden">
                  <img src={spec.src} alt={spec.title} className="w-full h-auto object-contain rounded-xl" />
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* 相关产品 */}
      <section className="py-16 md:py-24 px-4 md:px-8 lg:px-12 bg-background-100">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-2xl md:text-4xl font-bold text-foreground-900">相关产品推荐</h2>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 max-w-2xl mx-auto">
            {allInOneData.related.map((r) => (
              <Link key={r.href} to={r.href} className="group bg-white rounded-2xl overflow-hidden border border-background-200 hover:border-primary-200 transition-all duration-300 cursor-pointer">
                <div className="h-44 overflow-hidden">
                  <img src={r.image} alt={r.title} className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500" />
                </div>
                <div className="p-5">
                  <h4 className="text-sm font-bold text-foreground-900 mb-1">{r.title}</h4>
                  <p className="text-xs text-foreground-500">{r.desc}</p>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* 咨询表单 */}
      <ConsultationForm badge="商务咨询" title="在线咨询" subtitle="填写以下信息，我们的方案团队将在24小时内与您联系" />
    </>
  );
}

export default AllInOnePage;
